import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _storage = /*#__PURE__*/_classPrivateFieldLooseKey("storage");
export class StylesStorage {
  constructor(mode) {
    Object.defineProperty(this, _storage, {
      writable: true,
      value: void 0
    });
    this.read = () => {
      let rawData;
      try {
        rawData = _classPrivateFieldLooseBase(this, _storage)[_storage].getItem(StylesStorage.STORAGE_KEY);
      } catch (e) {
        return {};
      }
      if (!rawData) {
        return {};
      }
      try {
        return JSON.parse(rawData);
      } catch (e) {
        return {};
      }
    };
    this.persist = (id, stylesheet) => {
      const currentState = this.read();
      const updatedState = Object.assign({}, currentState, {
        [id]: stylesheet
      });
      this.write(updatedState);
    };
    this.remove = id => {
      const _this$read = this.read(),
        rest = _objectWithoutPropertiesLoose(_this$read, [id].map(_toPropertyKey));
      this.write(rest);
    };
    this.write = state => {
      try {
        _classPrivateFieldLooseBase(this, _storage)[_storage].setItem(StylesStorage.STORAGE_KEY, JSON.stringify(state));
      } catch (e) {
        return;
      }
    };
    _classPrivateFieldLooseBase(this, _storage)[_storage] = mode === 'session' ? window.sessionStorage : window.localStorage;
  }
  static getInstance(mode) {
    if (!StylesStorage.instances[mode]) {
      StylesStorage.instances[mode] = new StylesStorage(mode);
    }
    return StylesStorage.instances[mode];
  }
}
StylesStorage.STORAGE_KEY = '@@navigation/global-styles';
StylesStorage.instances = {};